export default "__VITE_ASSET__vGzWWfME__"